export default function createSearchCriteria(formValues) {
  const validKeys = [
    'advanced',
    'ancestralHall',
    'cameraOperatorId',
    'clan',
    'clanBranch',
    'creator',
    'custodian',
    'date',
    'endDate',
    'externalId',
    'firstAncestor',
    'generationPoem',
    'groupIds',
    'hasOrganizeActions',
    'includeDeprecatedGroups',
    'hasRework',
    'hasSupervisorReviewActions',
    'hasMissingCoverageData',
    // NOTE: honoredAncestor is deprecated but left here for backwards compatibility
    'honoredAncestor',
    'imageApid',
    'imageArk',
    'imageGroupNumbers',
    'keyword',
    'lifeEvent',
    'lifeEventIds',
    'lifeEventRecordTypeIds',
    'lifeEventRecordTypes',
    'mediaNumber',
    // TODO: Remove after modifiedFromDate is fully in use
    'modifiedDate',
    'modifiedFromDate',
    'modifiedToDate',
    'naturalGroupIds',
    'needsToBeOrganized',
    'nextPageToken',
    'originalWeekEnding',
    'page',
    'pageSize',
    'parentIds',
    'place',
    'projectId',
    'recordTypeId',
    'recordTypeIds',
    'romanizeLocale',
    'showUnknown',
    'sortBy',
    'sortOrder',
    'startDate',
    'startDateAvailable',
    'surname',
    'surnames',
    'title',
    'titleNumbers',
    'types',
    'volumeSetSearch',
    'collectionIds',
  ]

  return Object.entries(formValues).reduce((obj, [key, val]) => {
    if (!val || (Array.isArray(val) && val.length === 0)) {
      return obj
    }

    if (!validKeys.includes(key)) {
      console.error(
        `Invalid key: ${key}. If this is a new search input, please add it to the array in helpers/createSearchCriteria on line 3.`
      )
    }

    if (typeof val === 'string') obj[key] = val.replace(/\n/g, ', ')
    else if (typeof val === 'object' && key === 'place') obj.place = val.key
    else if (key !== 'date') obj[key] = val

    return obj
  }, {})
}
